import z from "zod";
import { PostSchema, sanitizeEmptyArrayAsRecord } from "../postSchema";
import { OlapScoresResultSchema } from "../../olapScores/olapScoresSchema";

export const PostListSchema = PostSchema.pick({
    id: true,
    organization: true,
    completions: true,
    isLocked: true,
    campaign: true,
    ssqId: true,
    ssqVersionId: true,
}).extend({
    olapScores: z.preprocess(sanitizeEmptyArrayAsRecord, OlapScoresResultSchema).optional(),
});
export type PostList = z.infer<typeof PostListSchema>;
